import { render } from "./StoreRequisitionApprovalList.vue?vue&type=template&id=41c1c7c8&scoped=true"
import script from "./StoreRequisitionApprovalList.vue?vue&type=script&lang=js"
export * from "./StoreRequisitionApprovalList.vue?vue&type=script&lang=js"

import "./StoreRequisitionApprovalList.vue?vue&type=style&index=0&id=41c1c7c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41c1c7c8"]])

export default __exports__